export default {
    title: "Przedmioty niedostarczone",
    header: "@:views.survey.deliveryfaq.title",
    result: {
        header: "Dziękuję",
        message: "Dziękuję za odpowiedź."
    },
    message: "Poinformowałeś, że nie otrzymałeś przesyłki, mimo że kurier oznaczył ją jako dostarczoną.",
    cta: "Aby pomóc nam rozwiązać ten problem, wykonaj poniższe kroki:",
    items: {
        1: {
            message: "Kliknij na link(i) śledzenia:"
        },
        2: {
            message: "Sprawdź status dostawy. Sprawdź:",
            items: {
                1: "Kto podpisał się pod paczką",
                2: "Jeżeli został zwrócony do nadawcy",
                3: "Jeśli przesyłka czeka na odbiór"
            }
        },
        3: {
            message: "Sprawdź, czy istnieje powiadomienie o dostawie wskazujące, gdzie przesyłka mogła zostać pozostawiona."
        },
        4: {
            message: "Sprawdź u sąsiadów, krewnych i znajomych, którzy mogli zabrać przesyłkę."
        }
    },
    question: "Czy to pomogło rozwiązać Twoje pytanie dotyczące dostawy? Czy masz teraz przedmiot lub wiesz, kto go ma? Odpowiedz poniżej",
    product: {
        name: "Nazwa przedmiotu",
        quantity: "Ilość",
        tracking: "Śledzenie",
    },
    buttons: {
        yes: "Tak",
        no: "NIE",
        saving: "Oszczędność"
    }
}